/**
 * Short context message injected by hooks/plugins as a reminder.
 * Points the agent toward the reponova-mcp skill for full guidance.
 */
export const HOOK_CONTEXT =
  "reponova: 11 MCP graph tools available for structural code queries. " +
  "Consult the reponova-mcp skill to know which tool to use. " +
  "Use graph_search instead of grep/find.";
